exports.components = {
  "component---src-templates-article-tsx": () => import("./../../../src/templates/Article.tsx" /* webpackChunkName: "component---src-templates-article-tsx" */),
  "component---src-templates-not-found-error-tsx": () => import("./../../../src/templates/NotFoundError.tsx" /* webpackChunkName: "component---src-templates-not-found-error-tsx" */),
  "component---src-templates-search-tsx": () => import("./../../../src/templates/Search.tsx" /* webpackChunkName: "component---src-templates-search-tsx" */),
  "component---src-templates-start-page-tsx": () => import("./../../../src/templates/StartPage.tsx" /* webpackChunkName: "component---src-templates-start-page-tsx" */)
}

